import Swiper from "swiper";
import {
  Navigation,
  Pagination,
  EffectFade,
  Autoplay
} from "swiper/modules";

// コア機能と各モジュールのCSSファイルをインポート
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "swiper/swiper-bundle.css";

import {
  remToPx,
  debounce,
  is_Mobile
} from "../../common";

Swiper.use([Navigation, Pagination, EffectFade, Autoplay]);

export const swiperMv = () => {
  const swiper = new Swiper(".swiper-mv", {
    direction: "horizontal",
    loop: true,
    slidesPerView: 1,
    touchStartPreventDefault: false,
    effect: "fade",

    fadeEffect: {
      crossFade: true,
    },

    autoplay: {
      delay: 3000,
      // disableOnInteraction: false,
    },

    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },

    // アニメーション速度を設定（ミリ秒単位）
    speed: 1000,
  });
};

export const swiperInterview = () => {
  return new Promise((resolve, reject) => {
    const swiper = new Swiper(".swiper-interview", {
      direction: "horizontal",
      loop: false,
      slidesPerView: 1,
      spaceBetween: remToPx(5),
      centeredSlides: false,
      touchStartPreventDefault: false,
      breakpoints: {
        768: {
          slidesPerView: 1.2,
          spaceBetween: remToPx(7),
          loop: true,
          centeredSlides: false,
        },
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      on: {
        init: function () {
          this.update();
          setTimeout(() => {
            resolve(this);
          }, 500);
        },
      },
    });
  });
};

export const swiperShortMovie = () => {
  const swiper = new Swiper(".swiper-movie", {
    direction: "horizontal",
    loop: true,
    slidesPerView: 1,
    spaceBetween: remToPx(4),
    preloadImages: false,
    initialSlide: 0,
    clickable: false,
    lazy: {
      loadPrevNext: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 3.7,
        spaceBetween: remToPx(5),
        loop: true,
      },
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    on: {
      resize: function () {
        const is_mobile = is_Mobile();
        if (is_mobile == "sp") {
          this.slideTo(0, 0);
        }
      },
    },
  });
};